import React from 'react';

import { FullscreenOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { Typography } from 'antd';

import { ActionButton } from 'components/Button/ActionButton';
import { FlexSpace } from 'components/FlexSpace';
import { FlexSpacer } from 'components/FlexSpacer';

import { DailyWorkflowCardBase } from './DailyWorkflowCardBase';

export type DataPoint = {
  title: string;
  value: string;
};

export type DailyWorkflowGraphCardProps = {
  title: string;
  sparkline: React.ReactNode;
  dataPoints: DataPoint[];
  onFullScreenClick: () => void;
};

export const DailyWorkflowGraphCard = ({
  title,
  sparkline,
  dataPoints,
  onFullScreenClick,
}: DailyWorkflowGraphCardProps) => (
  <DailyWorkflowCardBase
    title={title}
    headerActions={<ActionButton label={<FullscreenOutlined />} onClick={onFullScreenClick} />}
  >
    <FlexSpace
      direction="column"
      className={css`
        width: 100%;
        flex: 1 1 0;
        padding-bottom: 10px;
        padding-top: 6px;
      `}
    >
      {sparkline}
      {dataPoints.map((dataPoint, index) => (
        <FlexSpace
          direction="row"
          key={index}
          className={css`
            width: 100%;
          `}
        >
          <Typography.Text style={{ fontSize: 12 }}>{dataPoint.title}:</Typography.Text>
          <FlexSpacer />
          <Typography.Text style={{ fontSize: 12, fontWeight: 700, textAlign: 'right', whiteSpace: 'nowrap' }}>
            {dataPoint.value}
          </Typography.Text>
        </FlexSpace>
      ))}
    </FlexSpace>
  </DailyWorkflowCardBase>
);
